const _ = require('lodash');
const SHCEME = require('../../helpers/scheme');
const emailAlreadyUsed = _.get(SHCEME, 'email.properties.value.messages.emailAlreadyUsed');

let registration = require('../../actions/auth/registration');
let utils = require('../../actions/utils');
let redirect = require('../../actions/redirect');
let cookie = require('../../actions/cookie');
let authGroup = require('../groups/auth');
let login = require('../../actions/auth/login');
let user = require('../../actions/user');
let { loginSuccess } = require('../groups/auth/login');
let analytics = require('../../actions/analytics');
let { selectUserType } = require('../../actions/account/user-form');

let showLoginWithTooltip = [
    redirect.redirect('/login'),
    utils.set(['login', 'tooltip', 'showAlreadyRegisteredTooltip'], true),
    utils.unset(['login', 'form', 'password'])
];

let registerHermesUser = [
    [
        registration.registerHermesUser, {
            emailAlreadySend: [
                utils.set(['page', 'name'], 'alert'),
                utils.set(['auth', 'alert', 'type'], 'registrationSuccess'),
                analytics.argsValueEvent({ category: 'post_successful_registration', action: 'see' }),
                cookie.setSessionToken,
                cookie.unsetRegisterExtraToken,
                ...authGroup.createOrderAfterLoginIfNeededOrRedirect
            ],
            emailNotConfirmed: [
                utils.set(['page', 'name'], 'alert'),
                utils.set(['auth', 'alert', 'type'], 'approveRegistration'),
                analytics.argsValueEvent({ category: 'post_registration_after_email_validation', action: 'see' }),
                redirect.redirect('/', 15000)
            ],
            passportUserAlreadyAssociated: [
                // такого быть не может в нормальной ситуации, скорее всего мы послали запрос несколько раз
                utils.set(['registration', 'error', 'email'], emailAlreadyUsed)
            ],
            wrongCountryId: [
                utils.set(['auth', 'isCountryError'], true)
            ],
            error: [
                utils.set(['auth', 'isError'], true)
            ]
        }
    ]
];

module.exports = {
    showToS: [
        analytics.argsValueEvent({ category: 'popup_agreement', action: 'see' }),
        utils.set(['registration', 'showToS'], true)
    ],
    cancelToS: [
        utils.set(['registration', 'showToS'], false),
        registration.declinePersonalDataProcessing
    ],
    registration: [
        registration.acceptPersonalDataProcessing,
        utils.set(['registration', 'ui', 'registerButton', 'isDisabled'], true),
        // галочки согласия с регистрацией нет, поэтому соглашаемся за пользователя
        utils.set(['registration', 'form', 'isAcceptPersonalDataProcessing'], true),
        [
            registration.debouncedRegisterAuthUser, {
                success: [
                    ...registerHermesUser
                ],
                emailAlreadyUsed: [
                    // пользователь с таким e-mail уже зареган в Паспорте, пробуем залогироваться с указанным паролем
                    registration.fillLoginForm,
                    [
                        login.loginUser, {
                            success: [
                                [
                                    user.getUser, {
                                        allowed: [
                                            // пользователь уже везде был зареган - мы просто залогинились (внезапно?)
                                            ...loginSuccess
                                        ],
                                        403: [
                                            // аккаунт уже есть, но не подтверждён
                                            redirect.redirect('/login'),
                                            utils.setFromArgsToState('username', ['login', 'tooltip',
                                                'emailNotConfirmed', 'username']),
                                            utils.set(['login', 'tooltip', 'emailNotConfirmed', 'show'], true)
                                        ],
                                        404: [
                                            // пользователь не зареган в Гермесе - зарегаем, данные для этого есть
                                            ...registerHermesUser
                                        ],
                                        denied: [
                                            utils.set(['auth', 'isError'], true)
                                        ]
                                    }
                                ]
                            ],
                            invalidValidation: [
                                // пароль на подошёл, предложим залогинится с другим паролем и покажем подсказку
                                ...showLoginWithTooltip
                            ],
                            accessDenied: [
                                // пароль на подошёл, проверим зареган ли такой пользователь в Гермесе
                                utils.setArgFromState('email', ['registration', 'form', 'email']),
                                [
                                    user.isEmailAssociated,
                                    {
                                        yes:[
                                            utils.set(['registration', 'error', 'email'],
                                                'Пользователь с таким email<br> уже зарегистрирован')
                                        ],
                                        no:[
                                            ...showLoginWithTooltip,
                                        ],
                                        error:[]
                                    }
                                ]
                            ],
                            error: [
                                utils.set(['auth', 'isError'], true)
                            ]
                        }
                    ]
                ],
                error: [
                    utils.set(['auth', 'isError'], true)
                ]
            }
        ],
        utils.set(['registration', 'ui', 'registerButton', 'isDisabled'], false),
        utils.set(['registration', 'showToS'], false)
    ],
    setRegistrationProperty: [
        registration.setRegistrationProperty
    ],
    selectUserType: [
        selectUserType(['registration'])
    ],
    selectCountry: [
        utils.setArgByFunction('selectedValue', (args) => Number(args['selectedValue'])),
        utils.setFromArgsToState('selectedValue', ['registration', 'form', 'countryId']),
        [
            utils.isEqual(['registration', 'computed', 'isUserTypeSelectEnabled'], false),
            {
                yes: [
                    utils.set(['registration', 'form', 'userType'], 1),
                    utils.unset(['registration', 'userTypeRadio']),
                    utils.set(['registration', 'userTypeRadio', 1], true)
                ],
                no: []
            }
        ]
    ]
};



// WEBPACK FOOTER //
// ./signals/auth/registration.js